import { ChangeDetectionStrategy, Component, inject, type OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-invalid-user-tariff-modal',
    templateUrl: './invalid-user-tariff-modal.component.html',
    styleUrls: ['./invalid-user-tariff-modal.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, TranslateModule],
})
export class InvalidUserTariffModalComponent implements OnInit {
    private readonly bsModalRef: BsModalRef = inject(BsModalRef);

    public onClose: Subject<boolean>;

    public ngOnInit(): void {
        this.onClose = new Subject();
    }

    public onConfirm(): void {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }

    public onCancel(): void {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }
}
